import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import WellHighwayEditingDialog from '../DialogEditingType/WellHighwayEditingDialog';
import { ROLE_ADMIN, ROLE_ENGINNER } from '../../../Constants/ConstantsOptics';
import { WELL, WELL_FLAG } from '../../../Constants/ConstantsOptics';
import ModalDescriptionComponentSpecifically from '../../../Modal/ModalDescriptionComponentSpecifically';
import { fetchWellConnectionCount } from '../CountFile/ConnectionCount';
import { fetchWellFileCount } from '../CountFile/FileCount';
import DialogWellFoto from '../DialogFoto/DialogWellFoto';

const WellHighwayDialog = ({ open, onClose, content, snackbarOpen, snackbarMessage, snackbarClass,
    handleCloseSnackbar, copyToClipboard, role, user, highwayRefresh,
    groupedCoordinatesWithColorTypeAndWidth, wellData, fobLocationData, couplingLocationData, ponBoxLocationData, pillarData, setIsComponentСhangeCoor}) => {

  const [openModalEditing, setOpenModalEditing] = useState(false);
  const [openModalDescription, setOpenModalDescription] = useState(false);
  const [connectionCount, setConnectionCount] = useState(0);
  const [openModalFoto, setOpenModalFoto] = useState(false);
  const [fileCount, setFileCount] = useState(0);
 
  const openModalDescriptionComponents = () => {
    if(connectionCount != 0){
      setOpenModalDescription(true);
    }  
  }; 

   const openModalFotoFile = () => {
    if(fileCount != 0){
      setOpenModalFoto(true);
    }
  }; 

  const openModalEditingContent = () => {
     setOpenModalEditing(true);
  };  

   useEffect(() => {
      const updateFileCount = async () => {  
        const count = await fetchWellFileCount(content.id);
        if (count !== null) {
          setFileCount(count); 
        }
      };
      updateFileCount();
    });
  
  useEffect(() => {
    const updateConnectionCount = async () => {  
      const count = await fetchWellConnectionCount(content.id);
      if (count !== null) {
        setConnectionCount(count); 
      }
    };
    updateConnectionCount();
  });
  
  return (
    <Dialog open={open} className="dialogStyle">    
    <DialogContent>
    <img src='./manhole.png'  width='30' height='30' style={{marginRight: "5px"}}/>
    <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #3d3d3d'}}>Колодец</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',textShadow: '2px 2px 4px #3d3d3d' }}>{content.id}</span></label>
      <Button 
          style={{marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
          onClick={() => { copyToClipboard(content.id, "колодец"); }}>
          <FileCopyIcon style={{ color: '#e4c253'}}/>
        </Button>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Территория: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.city}</span> </label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Собственник: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.ownerWellName}</span> </label>
      <br/>
      {/* <label style={{ color: '#292929', fontWeight: 'bold'}}>Тариф/км: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.ownerWellPrice} грн.</span> </label> */}
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <label style={{ color: '#292929', fontWeight: 'bold', marginRight: '5px' }}>
          Координаты:
        </label>
        <div>
          <div style={{ color: '#bebebe', fontWeight: 'normal', textShadow: '2px 2px 4px #3d3d3d' }}>
            {content.latitude}
          </div>
          <div style={{ color: '#bebebe', fontWeight: 'normal', textShadow: '2px 2px 4px #3d3d3d' }}>
            {content.longitude}
          </div>
        </div>    
         <Button 
            style={{marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
            onClick={() => { copyToClipboard(`${content.latitude},${content.longitude} `, "Координаты"); }}>
            <FileCopyIcon style={{ color: '#e4c253'}}/>
        </Button>
      </div>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/>  
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.description}</span></label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/>

      <button onClick={openModalDescriptionComponents} class='buttonIsConnectionDialog' style={{textShadow: '2px 2px 4px #3d3d3d'}}>
        Связи
          <span className={`countCircle ${connectionCount > 0 ? 'green' : 'red'}`}>
            {connectionCount > 0 ? connectionCount : 'нет'}
          </span>
      </button>

       <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

      <button onClick={openModalFotoFile} className='buttonIsConnectionDialog' style={{textShadow: '2px 2px 4px #3d3d3d'}}>
        Просмотр файлов
        <span className={`countCircle ${fileCount > 0 ? 'green' : 'red'}`}>
           {fileCount > 0 ? fileCount : 'нет'}
        </span>
      </button>  

      <hr className='horizontalLineDialog'/>
    </DialogContent>

    <DialogActions>
    {((user === content.authorId && role.role === ROLE_ENGINNER) || role.role === ROLE_ADMIN) && (
      <Button onClick={openModalEditingContent} class='buttonIsEditDialog'>
          Редактироваать
      </Button>
    )}
      <Button onClick={onClose} class='buttonIsHideDrawer23'>
        Закрыть
      </Button>
    </DialogActions>

     {/* Snackbar */}
     <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={6000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

        {/* Modal Foto*/}
        <DialogWellFoto
           open={openModalFoto}
           onClose={() => setOpenModalFoto(false)}
           id={content.id}     
        />  

        <ModalDescriptionComponentSpecifically
          open={openModalDescription}
          onClose={() => setOpenModalDescription(false)}
          id={content.id}
          type={WELL}
          flag={WELL_FLAG}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
        />

      {/* Modal редактирование WellHighway*/}
      <WellHighwayEditingDialog
        open={openModalEditing}
        onClose={() => setOpenModalEditing(false)}
        onClose2={onClose}
        content={content}
        highwayRefresh={highwayRefresh}
        setIsComponentСhangeCoor={setIsComponentСhangeCoor}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        user={user}
      /> 
   </Dialog>   
  );
}

export default WellHighwayDialog;